module.exports = __webpack_public_path__ + "img/7.4d8e04b3.png";